export default __webpack_public_path__ + "static/media/silhouette-girl5.8d4b19c3.svg";